import { get } from 'utils/methods';

export default function getHistoryApi(stream, data, api, headers) {
    return get(`${api}history/${stream.group}/${stream.id}`, data, headers);
}
